import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const ProfilesSelector = styled('div')({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  padding: '48px 24px 24px 24px',
  backgroundColor: '#FFFFFF',
  height: '100%'
});

export const Description = styled(Typography)({
  color: '#5E6C84',
  fontSize: '14px',
  textAlign: 'center'
});

export const Header = styled(Typography)({
  textAlign: 'center',
  color: '#000000'
});

export const Profile = styled('div')({
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#F0F1F4',
  marginTop: '5px',
  padding: '16px 16px 16px 14px',
  cursor: 'pointer'
});

export const Profiles = styled('div')({
  width: '100%',
  padding: '24px 0 40px 0'
});

export const ProfileName = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  '& p': {
    marginLeft: '12px',
    color: '#5E6C84',
    flexShrink: 1
  },
  '& button': {
    backgroundColor: '#EFF7EE',
    width: '32px',
    height: '32px',
    '& svg': {
      width: '20px',
      height: '20px'
    }
  }
});